import { useContext, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./_style.scss";
import { httpAPI_APP016, httpAPI_PRE005 } from "./api/request";
import { fakeTableList, headList, schema } from "./parts";
import { IAPI_PRE005_Request, IAPI_PRE005_Response } from "../../type/apiType";
import { IAPI_APP016_Request } from "../../type/apiType";
import { Box } from "@mui/material";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkMemo from "../../components/molecules/TkMemo";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import {
  CommonOrCommonRetirementFlug,
  FormClassApply,
} from "../../assets/data/Constants";
import { TkGetCode } from "../../utils/TkGetCode";
import _ from "lodash";
import { isStatusAfterApproval } from "../../utils/useTools";

/**
 * SCRW080004 掛金納付延長申請　内容入力
 *
 * @returns JSX.Element
 */
const SCRW080004 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const [status, setStatus] = useState<any>();
  const [statecorpInfoList, setStatecorpInfoList] = useState<any>([]);
  const httpReqIApplicationStatusUpdateRequest: any = {};
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [responseData, setResponseData] = useState<IAPI_PRE005_Response>();
  const { state: businessState } = useContext(BusinessContext);
  const [bodyList, setBodyList] = useState<any>();
  const [fileList, setFileList] = useState<any>([]);
  const [corpApplyKbn] = useState<any>();
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  const handleInit = async () => {
    let resData: IAPI_PRE005_Request = {
      applyId: location.state.applyId
        ? location.state.applyId
        : businessState?.job_12?.applyId!,
      contractorNo: businessState?.common?.contractorNo!,
    };
    try {
      const res = await httpAPI_PRE005({
        ...resData,
      });

      if (res.resultCd === "I0000") {
        setResponseData(res);
        setStatus(res.latestApplyStatus);
        // setCorpApplyKbn(res.corpApplyKbn);
        let resArr = stateFakeTableList.current;
        // 初期表示
        const bodyListData: any = [];

        res.statusList?.forEach((item: any) => {
          const data = [
            { children: item.managerName },
            { children: item.process },
            { children: item.createDate, align: "center" },
            { children: item.processComment },
          ];
          bodyListData.push(data);
        });
        setBodyList(bodyListData);

        resArr.find((item) => item.keyword === "reasons")!.setDefaultValue =
          res?.extensionApplyReason;

        resArr.find((item) => item.keyword === "premiumsForExtensio")!.text =
          (res.year ?? "") + "　年度分";

        resArr.find(
          (item) => item.keyword === "premiumsForExtensioAmount"
        )!.text = (res.premiumAmt ?? "") + "　円";

        resArr.find((item) => item.keyword === "applyDate")!.setDefaultValue =
          res.expectDeadline;

        resArr.find(
          (item) => item.keyword === "deadlineBeforeExtension"
        )!.text = res.paymentDeadline;

        resArr.find((item) => item.keyword === "remark")!.setDefaultValue =
          res?.remark;

        // 延長申請の理由証明書
        res.formList?.forEach((item) => {
          if (item.formClass === "4" && item.formKbn === "3") {
            resArr.find((item) => item.keyword === "downloadLink1")!.showLine =
              true;
            resArr.find(
              (item) => item.keyword === "downloadLink1"
            )!.base64filedata = item.fileBase64;
            resArr.find((item) => item.keyword === "downloadLink1")!.dataname =
              item.fileName;
          }
        });

        let file = res.formList?.find(
          (item) => item.formClass === "EXP0301010"
        );
        let showLine = isStatusAfterApproval(res.latestApplyStatus);
        let bodyList = [
          [
            {
              children: file ? (
                <TkDownloadLink
                  dataname={TkGetCode(FormClassApply, file?.formClass)}
                  base64filedata={file?.fileBase64!}
                  downloadBase64
                />
              ) : null,
            },
            {
              children: showLine && res.symbolNo,
            },
            {
              children: showLine && res.approvalDate,
            },
          ],
        ];
        setFileList(bodyList);

        setStatecorpInfoList(resArr);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeHttpObj = (data: IAPI_APP016_Request, num: any, formData?: any) => {
    data.applyEvent = num;
    data.reason = memoData;
    data.applyId = responseData?.applyId!;
    if (memoCheck) {
      data.inquiryCode = "1";
    }
    if (formData?.symbolNumber !== undefined) {
      data.symbolNo =
        TkGetCode(CommonOrCommonRetirementFlug, formData.symbolNumberType) +
        "第" +
        formData.symbolNumber +
        "号";
      data.decisionDate = formData.settlementDate;
    }
    data.contractorNo = businessState?.common?.contractorNo!;
    data.screenId = "SCRW080004";
    return data;
  };
  const btnEvent = async (btnName: any) => {
    const num =
      btnName === "拒絶"
        ? "10"
        : btnName === "郵送"
        ? "11"
        : btnName === "契約者に差戻し"
        ? "5"
        : btnName === "受理"
        ? "2"
        : btnName === "承認"
        ? "3"
        : btnName === "担当者に差戻し"
        ? "8"
        : btnName === "課長代理確認"
        ? "14"
        : btnName === "課長代理拒絶確認"
        ? "15"
        : btnName === "上長承認"
        ? "6"
        : btnName === "上長拒絶承認"
        ? "7"
        : null;
    if (num === null) {
      return;
    }
    if (num === "3") {
      setIsOpen(true);
      return;
    }

    let reqData: IAPI_APP016_Request = makeHttpObj(
      httpReqIApplicationStatusUpdateRequest,
      num
    );

    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    }
    if (event.target.type === "checkbox") {
      setMemoCheck(event.target.value);
    }
  };

  const handleSave = async (formData: any) => {
    let reqData: IAPI_APP016_Request = makeHttpObj(
      httpReqIApplicationStatusUpdateRequest,
      "3",
      formData
    );
    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };
  const setOpen = () => {
    setIsOpen(false);
  };
  return (
    <Box className="SCRW080004" data-testid="SCRW080004PageForTest">
      <TkKikoStepper
        applicationFlowType="TYPE1"
        businessType="JOB-12"
        corporateApplicationClassification={corpApplyKbn}
        applicationStatus={status}
      />
      {/* TkInfoManualを表示 */}
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW080004_01}</TkInfoManual>
      <Box>
        <TkContractorAndNumberLine
          name={"契約者（法人）名"}
          no={
            businessState?.common?.contractorNo +
            ":" +
            businessState?.common?.contractorName
          }
        />
        <TkFakeTable
          list={statecorpInfoList}
          ruleSchema={schema}
          showButton={false}
        />

        <TkMemo showTable={true} bodyList={bodyList} onChange={onChange} />

        <Box className="TkFakeTable2">
          <TkTableWithNoLine headList={headList} bodyList={fileList} />
        </Box>

        <Box className="btn">
          <TkBackButton className="tkBottonMr" />
          <TkViewButtonJudgement
            flowType={"TYPE1"}
            Status={status}
            onClick={btnEvent}
            data-testid="TkViewButtonJudgement"
          />
        </Box>
        <TkApprovalDateSymbolNumberRegistrationDialog
          data-testid="SCRW080004PageForDialog"
          open={isOpen}
          onSuccess={handleSave}
          onClose={setOpen}
        />
      </Box>
    </Box>
  );
};

export default SCRW080004;
